"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _class; // reminder to not import AppUI to avoid circular dependencies
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var RootState = (_class = /*#__PURE__*/function () {
  function RootState() {
    _classCallCheck(this, RootState);
  }
  return _createClass(RootState, [{
    key: "set",
    value: function set(field, value) {
      this[field] = value;
    }
  }, {
    key: "toggle",
    value: function toggle(field) {
      this[field] = !this[field];
    }
  }, {
    key: "incrementId",
    value: function incrementId(ary, field) {
      this[field] = StateHelper.incrementId(ary, this[field]);
    }
  }, {
    key: "decrementId",
    value: function decrementId(ary, field) {
      this[field] = StateHelper.decrementId(ary, this[field]);
    }
  }]);
}(), _applyDecoratedDescriptor(_class.prototype, "set", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "set"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggle", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "incrementId", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "incrementId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "decrementId", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "decrementId"), _class.prototype), _class);
var _default = exports["default"] = RootState;